import { SoggettiPraticaDto, SoggettoDto } from "@api/client";
import { createReducer } from "@reduxjs/toolkit";
import { TipoSoggetto } from "constants/global";
import {
	clearSubjects,
	subjectGetDetails,
	subjectGetSubject,
	subjectSetIdLegaleRappresentante,
	subjectSetSubjectDetail,
	subjectSetSubjects,
	subjectSetTitolariEffettiviAdded,
	subjectUpdateSubject,
} from "./actions";

interface SubjectReducerType {
	subjects: SoggettiPraticaDto | undefined;
	titolariEffettiviAdded: any;
	subject: SoggettoDto | undefined;
	idLegaleRappresentante: string | undefined;
}

const initialState: SubjectReducerType = {
	subjects: sessionStorage.getItem("subjectDetail")
		? JSON.parse(sessionStorage.getItem("subjectDetail") || "")
		: undefined,
	titolariEffettiviAdded: undefined,
	subject: undefined,
	idLegaleRappresentante: undefined,
};

export const subjectReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(subjectSetSubjects, (state, action) => {
			sessionStorage.setItem("subjectDetail", JSON.stringify(action.payload));
			state.subjects = action.payload;
		})
		.addCase(subjectSetSubjectDetail, (state, action) => {
			if (action.payload?.tipoSoggetto === TipoSoggetto.LR && state.subjects) {
				state.subjects.legaleRapp = action.payload;
			} else {
				const elencotitolariEffettiviArray = Array.from(
					state.subjects?.elencoTitolariEffettivi || []
				);
				const index = elencotitolariEffettiviArray.findIndex(
					(soggetto) => soggetto.id === action.payload.id
				);
				if (index !== -1) {
					elencotitolariEffettiviArray[index] = action.payload;
				}
			}
		})
		.addCase(subjectSetTitolariEffettiviAdded, (state, action) => {
			state.titolariEffettiviAdded = action.payload;
		})
		// TODO: qusti ultimi due reducer servono?
		.addCase(subjectGetDetails.fulfilled, (state, { payload }) => {
			state.subjects = payload;
		})
		.addCase(subjectUpdateSubject.fulfilled, (state, { payload }) => {
			if (payload) {
				if (payload?.tipoSoggetto === TipoSoggetto.LR && state.subjects) {
					state.subjects.legaleRapp = payload;
				} else {
					if (state.subjects) {
						if (!state.subjects?.elencoTitolariEffettivi) {
							state.subjects.elencoTitolariEffettivi = [];
						}
						const index = state.subjects.elencoTitolariEffettivi.findIndex(
							(soggetto) => soggetto.id === payload?.id
						);
						if (index !== -1) {
							state.subjects.elencoTitolariEffettivi[index] = payload;
						} else {
							state.subjects.elencoTitolariEffettivi.push(payload);
						}
					}
				}
				state.subject = payload;
			}
		})
		.addCase(subjectGetSubject.fulfilled, (state, action) => {
			state.subject = action.payload;
		})
		.addCase(subjectSetIdLegaleRappresentante, (state, action) => {
			state.idLegaleRappresentante = action.payload;
		})
		.addCase(clearSubjects, (state) => {
			state.subjects = undefined;
			state.titolariEffettiviAdded = undefined;
			state.subject = undefined;
			state.idLegaleRappresentante = undefined;
		});
});
